var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscountShape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/discount-shape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "discount-shape"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M19.95 73.2997L12.35 65.6999C9.25002 62.5999 9.25002 57.4999 12.35 54.3999L19.95 46.7998C21.25 45.4998 22.3 42.9498 22.3 41.1498V30.4C22.3 26 25.9 22.3998 30.3 22.3998H41.05C42.85 22.3998 45.4 21.3499 46.7 20.0499L54.2999 12.4498C57.3999 9.34982 62.5 9.34982 65.6 12.4498L73.2001 20.0499C74.5001 21.3499 77.05 22.3998 78.85 22.3998H89.6001C94.0001 22.3998 97.6 26 97.6 30.4V41.1498C97.6 42.9498 98.65 45.4998 99.95 46.7998L107.55 54.3999C110.65 57.4999 110.65 62.5999 107.55 65.6999L99.95 73.2997C98.65 74.5997 97.6 77.1497 97.6 78.9498V89.6999C97.6 94.0999 94.0001 97.6997 89.6001 97.6997H78.85C77.05 97.6997 74.5001 98.7499 73.2001 100.05L65.6 107.65C62.5 110.75 57.3999 110.75 54.2999 107.65L46.7 100.05C45.4 98.7499 42.85 97.6997 41.05 97.6997H30.3C25.9 97.6997 22.3 94.0999 22.3 89.6999V78.9498C22.3 77.0997 21.25 74.5497 19.95 73.2997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M75 80C72.2 80 69.95 77.75 69.95 75C69.95 72.25 72.2 70 74.95 70C77.7 70 79.95 72.25 79.95 75C79.95 77.75 77.75 80 75 80Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M45.05 50C42.25 50 40 47.75 40 45C40 42.25 42.25 40 45 40C47.75 40 50 42.25 50 45C50 47.75 47.8 50 45.05 50Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M45 78.7499C44.05 78.7499 43.1 78.4 42.35 77.65C40.9 76.2 40.9 73.7997 42.35 72.3497L72.35 42.3497C73.8 40.8997 76.2 40.8997 77.65 42.3497C79.1 43.7997 79.1 46.2 77.65 47.65L47.65 77.65C46.9 78.4 45.95 78.7499 45 78.7499Z",
    fill: "white"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountShape);
export default __webpack_public_path__ + "static/media/discount-shape.a40d22349af467b722630365d76dc441.svg";
export { ForwardRef as ReactComponent };